<script>
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap

import { useToast } from "vue-toastification";
	
//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';
import { defineComponent } from 'vue'

import UploadPhoto from '@/components/Core/Photos/uploadPhoto/uploadPhoto'

//data
import { getGalleryInfo,getGalleryOptions } from '@/services/serviceGallery';
import { getPhotosPreviewByGallery } from '@/services/servicePhoto';

export default defineComponent ({
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'ArticleSelectIntroPhotoSeo',
	mixins: [ MixinGeneralFunct ],
	components: {
		UploadPhoto
	},
	props: {'articlePhotoId': String, 'auth':Object, 'secData':Object, 'modalObject': Object, 'modalId': String},
	emits: ["articlePhotoId","changeAfterSelect"],
	data() {
		return {
			prefix:'',
			
			params:[],
			accData: [],

			//modals
			uploadPhotoMODAL:{},
			modalUploadID:'',
			
			preloader:true,
						
			optionsGalleries:[],
			selectedGallery:'',

			//form
			gallery:[],
			photos:[]
		}
	},
	
	mounted:function(){
		this.modalUploadID = `modal${this.getRandomInt(999999999)}`;
	},
	
	methods: {
		// load data form
		onLoadPage:function(){
			
			this.preloader=true
			
		
			getGalleryInfo({galleryId:this.selectedGallery}).then(response => {
				if(!response.statusText){
					this.gallery = response.data;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getGalleryOptions().then(response => {
				if(!response.statusText){
					this.optionsGalleries = response.optionsGalleries;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getPhotosPreviewByGallery({galleryId:this.selectedGallery}).then(response => {
				if(!response.statusText){
					this.preloader=false
					this.photos = response.photos;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		
		},

		//modal box upload photos
		loadModalFormUploadPhoto:function(){
			this.uploadPhotoMODAL = new bootstrap.Modal(document.getElementById(this.modalUploadID), {backdrop:'static'})
			this.uploadPhotoMODAL.show();
		},
		
		onCloseModal:function(){
			this.modalObject.hide();
		},
		
		//vybratie fotky
		selectPhoto:function(photoId){
			this.$emit('changeAfterSelect', photoId)
			this.modalObject.hide();
			this.toast.success(this.$t('msgCore.photoWasSelected'));
		},

		reloadAfterAddedPhoto() {
			this.onLoadPage();	
		},
		
	},
	
	watch: {
		articlePhotoId() {
			this.onLoadPage();
		}
	},

	computed:{
		
	},
	
})

</script>

<template>
<div>
	
	<div class="modal fade" :id="modalId" tabindex="-1" >
		<div class="modal-dialog modal-fullscreen modal-dialog-scrollable">
			<div v-show="preloader" class="preloader"><div class="spinner"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div></div>
			<div class="modal-content">
				<div class="modal-header">
					<h6 class="modal-title">{{ $t('msgCore.Preview') }} <b><span>{{ gallery.title }}</span></b></h6>
				</div>
				
				<div class="modal-body">
				
					<div class="form-group col-md-4 col-12">
						<label><b>{{ $t('msgCore.Gallery') }}</b></label>
						<div class="input-group">
						<select v-model='selectedGallery' class="form-control form-control-sm" v-on:change="onLoadPage()">
							<option  value="">{{ $t('msgCore.selectGallery') }}</option>
							<option v-for="(option) in optionsGalleries" :value="option.value" :key="option">{{ option.title }}</option>
						</select>
						<button :disabled="!auth.photosUpload || !selectedGallery" type="button" v-on:click="loadModalFormUploadPhoto()" :title="$t('msgCore.btnUpload')" class="btn btn-primary btn-sm"><i class="smire-icon fas fa-plus"></i> {{ $t('msgCore.btnAdd') }} novú fotku</button>
						</div>
					</div>
					
					<div class="row">
						<div class="col-12">
							<div v-for="photo in photos" class="crop_gallery2" :key="photo">
								<img :src="photo.photoUrlThumb" :title="photo.title">
								<button type="button" v-on:click="selectPhoto(photo.id)" :title="$t('msgCore.btnSelectPhoto')" id="modalObjectBtn" class="btn btn-primary btn-sm" style="position:absolute; bottom:0; right:0;"><i class="smire-icon fas fa-check"></i></button>
							</div>
						</div>
					</div>						
				</div>
				
				<div class="modal-footer">
					<div class="btn-group">
						<button type="button" v-on:click="onCloseModal()" class="btn btn-default btn-sm">{{ $t('msgCore.btnClose') }}</button>

						
					</div>	
				</div>
					
			</div>

		</div>
		
	</div>
	
	<UploadPhoto :auth="auth" :galleryId="String(selectedGallery)" @changeAfterUpload="reloadAfterAddedPhoto" :modalObject="uploadPhotoMODAL"  :modalId="modalUploadID"></UploadPhoto>
</div>
</template>


